import pushNotification from '@apis/pushNotification'
import Button from '@components/button'
import Fields from '@components/fields'
import Grid from '@components/grid'
import Row from '@components/row'
import Wrapper from '@components/wrapper'
import { outlineButton } from '@pages/admin/payment/settings/form'
import { Form, Formik } from 'formik'
import React, { Fragment, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const PushNotificationForm = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [initialValues, setInitialValues] = useState({
    title: '',
    body: '',
    image: '',
  })

  useEffect(() => {
    setInitialValues({
      title: state?.title,
      body: state?.description,
      image: state?.image,
    })
  }, [state])

  const handleSubmit = async (values: any, { resetForm }) => {
    try {
      const imagePayload = values.image?.base64
        ? {
            base64: values.image.base64,
            extension: values.image.extension,
          }
        : state?.image || null

      const payload = {
        title: values.title,
        body: values.body,
        ...(imagePayload && { image: imagePayload }),
      }

      if (!!state) {
        await pushNotification.update({
          state: 'pushNotification',
          data: JSON.stringify(payload),
          id: state.id,
        })
      } else {
        await pushNotification.create({
          state: 'pushNotification',
          data: JSON.stringify(payload),
        })
      }

      resetForm()
    } catch (error) {}
  }

  return (
    <Fragment>
      <Wrapper>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          <Form>
            <div style={{ display: 'flex' }}>
              <Grid repeat={1} styleGrid={`width: 200%;`}>
                <Fields.Input
                  name="title"
                  label="Title"
                  placeholder="Type here"
                  styleInput="width:97%"
                />
                <Fields.TextArea
                  name="body"
                  label="Description "
                  placeholder="Type here"
                />
              </Grid>

              <Fields.Upload name="image" variant="banner" />
            </div>

            <Row styleRow="justify-content:flex-end; margin-top:20px; gap: 12px;">
              <Button
                type="reset"
                title="Reset"
                height={45}
                width={100}
                styleButton={outlineButton}
              />

              {!!state && (
                <Button
                  title="Cancel"
                  height={45}
                  width={100}
                  onClick={() => navigate(-1)}
                  styleButton={`
                    background-color: #dc3545;
                    color: white;
                    border: none;
                  `}
                />
              )}

              <Button
                title={!!state ? 'Update' : 'Submit'}
                height={45}
                width={100}
                type="submit"
              />
            </Row>
          </Form>
        </Formik>
      </Wrapper>
    </Fragment>
  )
}

export default PushNotificationForm
